<template>
  <v-slider
    :disabled="disabled"
    v-model="sliderValue"
    color="green lighten-1"
    step="10"
    ticks="always"
    track-color="grey"
    thumb-label="always"
    :append-icon="icon"
    prepend-icon="mdi-currency-eur"
  >
    <template v-slot:thumb-label="{ value }">
      {{ satisfactionEmojis[Math.min(Math.floor(value / 10), 10)] }}
    </template>
  </v-slider>
</template>

<script lang="ts">
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ThgImpactFactorSlider extends Vue {
  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: ImpactTypeEnum.trees })
  impactType!: ImpactTypeEnum;

  get sliderValue(): number {
    return ThgCreateModule.impactFactor;
  }

  set sliderValue(value: number) {
    ThgCreateModule.setImpactFactor(value);
  }

  get icon(): string {
    return ThgCreateModule.impactTypeItem.icon;
  }

  updateImpactFactor() {
    ThgCreateModule.setImpactFactor(this.sliderValue);
  }

  satisfactionEmojis = ["😢", "🙂", "😊", "😀", "😄", "😁", "😎", "🤩", "😍", "🚀", "💚"];
}
</script>

<style>
.form {
  margin-top: 20px;
}
</style>
